import { Channel } from '@shared/types/channel';

export const channels: { reference: Channel; title: string }[] = [
  { reference: 'reseller', title: 'Reseller' },
  { reference: 'retail', title: 'Retail' },
  { reference: 'direct_sales', title: 'Direct Sales' },
  { reference: 'oem', title: 'OEM' },
  { reference: 'local_e_tailer', title: 'Local E-Tailer' },
  { reference: 'local_e_store', title: 'Local E-Store' },
  { reference: 'global_e_tailer', title: 'Global E-Tailer' },
  { reference: 'msp', title: 'MSP' },
  { reference: 'var_and_vad', title: 'VAR and VAD' },
  { reference: 'cloud_old', title: 'Cloud (Old)' },
  { reference: 'telco_old', title: 'Telco (Old)' },
  { reference: 'not_specified', title: 'Not Specified' },
  { reference: 'mass_retail_old', title: 'Mass Retail (Old)' },
  { reference: 'global_e_store', title: 'Global E-Store' },
  { reference: 'telco', title: 'Telco' },
  { reference: 'isp', title: 'ISP' },
  { reference: 'other', title: 'Other' },
];
